import {gql} from "@apollo/client";

export interface SlackChannel {
	id: string;
	name: string;
}

export interface SlackInfo {
	connected: boolean;
	state: string;
	scope: string;
	clientId: string;
	redirectUrl: string;
	authUrl: string;
}

const SLACK_CHANNEL_FRAGMENT = gql`
	fragment SlackChannelFields on SlackChannel {
		id
		name
	}
`;

const SLACK_INFO_FRAGMENT = gql`
	fragment SlackInfoFields on SlackInfo {
		connected
		state
		scope
		clientId
		redirectUrl
		authUrl
	}
`;

export const GET_SLACK_CHANNELS = gql`
	query SlackChannels {
		slackChannels {
			...SlackChannelFields
		}
	}
	${SLACK_CHANNEL_FRAGMENT}
`;

export const GET_SLACK_INFO = gql`
	query SlackInfo {
		slackInfo {
			...SlackInfoFields
		}
	}
	${SLACK_INFO_FRAGMENT}
`;

export const DISCONNECT_SLACK = gql`
	mutation DisconnectSlack {
		disconnectSlack {
			...SlackInfoFields
		}
	}
	${SLACK_INFO_FRAGMENT}
`;
